module.exports = __webpack_public_path__ + "static/media/Maple-Hill-By-Laws-1990.9065a27d.pdf";